import { get, post } from "@/utils/http";
// import contentType from "@/utils/content-type";

let baseURL = "/login";
let userURL = "/user";
//登录
const login = data => post(`${baseURL}/dologin`, { data });
//退出
const logout = data => get(`${baseURL}/logout`, data);
// 登录公钥
const userKey = data => get(`${baseURL}/getPublicKey`, data);

// 查询用户管理页面所有用户信息
const findAll = data => post(`${userURL}/findAll`, { data });

// 添加用户
const createUserInfo = data => post(`${userURL}/createUserInfo`, { data });
// 编辑
const updateUserInfo = data => post(`${userURL}/updateUserInfo`, { data });
// 删除用户信息
const deleteUserInfo = data => post(`${userURL}/deleteUserInfo`, { data });
//修改密码
const changePassword = data => get(`${userURL}/changePassword`, data);

//修改密码
const updatePassword = data => post(`${userURL}/updatePassword`, { data });
// userAPI
export default {
  login,
  logout,
  userKey,
  findAll,
  createUserInfo,
  updateUserInfo,
  deleteUserInfo,
  changePassword,
  updatePassword
};
